<div
	(click)="onClickCard()"
	class="proceso-card performance-custom-shadow grid grid-cols-[auto_1fr] items-center bg-white rounded-lg cursor-pointer"
>
	<!-- icono del proceso -->
	<div
		class="proceso-icon flex items-center justify-center rounded-l-lg bg-primary_ultra_light_variant shrink-0 h-full"
	>
		<mat-icon class="mdi mdi-chart-timeline-variant text-3xl text-primary"></mat-icon>
	</div>

	<!-- tipo + nombre + pendientes -->
	<div class="flex flex-col min-w-0 gap-2 grow-default p-4">
    <div class="flex items-center justify-between grow-default">
      <span class="text-base font-bold text-default_text truncate">{{ process?.name }}</span>
      <app-goal-status-chip [status]="process?.status?.code" [label]="process?.status?.name"></app-goal-status-chip>
    </div>
		<span class="text-xxs text-light_text truncate">Disponible hasta el {{ process?.schedule_finishes_at }}</span>
	</div>
</div>
